import { render, staticRenderFns } from "./processMethod.vue?vue&type=template&id=4fcfc61a&scoped=true&"
import script from "./processMethod.vue?vue&type=script&lang=js&"
export * from "./processMethod.vue?vue&type=script&lang=js&"
import style0 from "./processMethod.vue?vue&type=style&index=0&id=4fcfc61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcfc61a",
  null
  
)

export default component.exports